import styled from '@emotion/styled';
import { vars } from '@teamsparta/stack-tokens';
import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';

export const DropdownMenuTrigger = styled.button<{ opened?: boolean }>`
  padding: 6px 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease-in-out;
  display: flex;
  align-items: center;
  gap: 3px;
  background-color: ${({ opened }) =>
    opened ? vars.neutralWhiteAlpha[8] : 'transparent'};

  &:hover {
    background-color: ${vars.neutralWhiteAlpha[8]};
  }
`;

export const DropdownMenuContent = styled(motion.div)`
  position: fixed;
  top: var(--desktop-gnb-height);
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 32px 0 40px;
  z-index: 20;
  align-items: flex-start;
  gap: 40px;
  background: linear-gradient(
    0deg,
    rgba(178, 23, 18, 0.2) 0%,
    rgba(20, 22, 23, 0.2) 100%
  );
  backdrop-filter: blur(30px);
`;

export const StyledLink = styled(Link)`
  width: 432px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 24px;
  border-radius: 8px;
  background-color: #00000080;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background: rgba(14, 15, 17, 0.5);
  }
`;

export const Container = styled.div`
  padding: 20px;
  width: 472px;
  position: relative;
`;
export const AbsoluteImageWrapper = styled(Image)`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 12px;
  z-index: -1;
`;

export const IconImageWrapper = styled(Image)`
  border-radius: 16px;
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  background: linear-gradient(
    316deg,
    ${vars.brand.subtlest} 1.75%,
    rgba(0, 0, 0, 0.6) 60.7%,
    rgba(0, 0, 0, 0.6) 100%
  );
  box-shadow:
    -3px -3px 2px 0 rgba(100, 100, 100, 0.1) inset,
    3px 3px 3px 0 rgba(255, 255, 255, 0.1) inset;
  opacity: 0.8;
`;

export const Divider = styled.div`
  width: 1px;
  height: 200px;
  background: ${vars.neutralWhiteAlpha[20]};
  margin: auto 40px;
`;
